import React, { useState } from 'react'
import { StyledThirdForm } from './styled'
import { FormProvider, useForm } from 'react-hook-form'
import { API } from '../../../../../../javascripts/api'
import { CategorySkillOptions } from './types'
import { WorkPreferenceFormNames } from '../../constants'
import { AxiosError } from 'axios'
import { ThirdFormProps } from './types'

type FormValues = {
  categorizedSkills: {
    [key: number]: {
      categoryId: number;
      masterSkillId: number;
      year?: number | '';
      name?: string;
      isFocusSkill?: boolean;
    }[]
  };
}

export const ThirdForm: React.FC<ThirdFormProps> = (props: ThirdFormProps) => {
  const [skillOptions, setSkillOptions] = useState<CategorySkillOptions>({})

  const method = useForm<FormValues>(
    {
      defaultValues: async () => {
        const [skillResponse,categoryResponse] = await Promise.all([
          API.getUserSkillRelations(),
          API.getSkillCategories()
        ])

        const userSkills = skillResponse.data
        const categories = categoryResponse.data

        // ユーザーの既存スキルIDを取得
        const existingSkillIds = userSkills.map(skill => skill.masterSkillId)

        // カテゴリーごとのスキルオプションを作成
        const options = categories.reduce((acc, category) => {
          if (category.types?.length > 0) {
            acc[category.id] = category.types.flatMap(type =>
              type.skills
                .filter(skill => !existingSkillIds.includes(skill.id))
                .map(skill => ({
                  value: skill.id,
                  label: skill.skill_name
                }))
            )
          } else {
            acc[category.id] = category.skills
              ?.filter(skill => !existingSkillIds.includes(skill.id))
              .map(skill => ({
                value: skill.id,
                label: skill.skill_name
              })) || []
          }
          return acc
        }, {})

        // スキルオプションを状態にセット
        setSkillOptions(options)

        // ユーザーの既存スキルをカテゴリーごとに分類
        const categorizedSkills = userSkills.reduce((acc, skill) => {
          for (const category of categories) {
            let foundSkill = null

            if (category.types?.length > 0) {
              for (const type of category.types) {
                foundSkill = type.skills.find(s => s.id === skill.masterSkillId)
                if (foundSkill) break
              }
            } else {
              foundSkill = category.skills?.find(s => s.id === skill.masterSkillId)
            }

            if (foundSkill) {
              if (!acc[category.id]) {
                acc[category.id] = []
              }

              acc[category.id].push({
                categoryId: category.id,
                masterSkillId: skill.masterSkillId,
                year: typeof skill.year === 'number' ? skill.year : '',
                name: foundSkill.skill_name,
                isFocusSkill: skill.isFocusSkill
              })
            }
          }
          return acc
        }, {})

        return {
          categorizedSkills: categorizedSkills,
        }
      }
    })


  const onSubmit = async (data: FormValues) => {
    if (props.onSubmit) {
      props.onSubmit()
    }

    const skills = Object.values(data.categorizedSkills)
      .flat()
      .filter(skill => skill !== null && skill !== undefined);

    const submitData = {
      userSkillRelations: skills.map(skill => ({
        master_skill_id: skill.masterSkillId,
        year: skill.year,
        is_focus_skill: skill.isFocusSkill
      }))
    }

    try {
      await API.updateUserSkillRelations(submitData)
    } catch (e) {
      if (e instanceof AxiosError && e.response.data.error) {
        alert(e.response.data.error)
      } else {
        console.error(e)
        alert('エラーが発生しました。')
      }

      if (props.onError) {
        props.onError()
      }

      return
    }

    props.onChangeStep('next')
  }

  return (
    <FormProvider {...method}>
      <form id={WorkPreferenceFormNames.Skills} onSubmit={method.handleSubmit(onSubmit)} noValidate>
        <StyledThirdForm formType={props.formType} skillOptions={skillOptions} />
      </form>
    </FormProvider>
  )
}
